import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 8.5
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 11.2v5.3M12 7.8v.3" })
	]
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
